import { Button, Grid, Icon, TextareaAutosize } from '@mui/material';
import React, { ChangeEvent, Component } from 'react';
export class EntradaTexto extends Component {

    handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        console.log(`Novo texto: ${e.currentTarget.value}`)
    }

    handleEnviarMensagem = () => {

            console.log("Botão enviar clicado!");
    }

    render() {
        return (
            <Grid >
                <TextareaAutosize onChange={this.handleChange} />
                <Grid>
                    <Button
                        color="primary"
                        variant="contained"
                        disableElevation
                        onClick={this.handleEnviarMensagem}
                        startIcon={<Icon>message</Icon>}
                    >
                        Enviar
                    </Button>
                </Grid>
            </Grid>
        );
    }
}